import {
  Badge,
  HStack,
  Icon,
  IconButton,
  Image,
  StackProps,
  Text,
  VStack,
} from "@chakra-ui/react";
import { RiCloseCircleLine } from "@remixicon/react";
import { useNavigate } from "react-router-dom";
import { ProductChatInterface } from "../../constants/Chat";
import { useDarkWhiteColor } from "../../themes/colors";
import formatNumber from "../../utils/helperFunction";

interface Props extends StackProps {
  data: ProductChatInterface | undefined | null;
  onCloseProduct?: () => void;
}

export const ProductChat = ({ data, onCloseProduct, ...rest }: Props) => {
  const bgBnw = useDarkWhiteColor();
  const navigate = useNavigate();

  return (
    <HStack
      marginBottom={{ base: "60px", md: 0 }}
      w={"100%"}
      p={2}
      borderRadius={"lg"}
      bg={bgBnw}
      alignSelf={"stretch"}
      justify={"space-between"}
      alignItems={"start"}
      {...rest}
    >
      {data?.name === undefined || data?.variantName === undefined ? (
        <>
          <Icon
            as={RiCloseCircleLine}
            opacity={0.6}
            fontSize={[10, null, 12]}
            alignSelf={"center"}
          />

          <Text as={"i"} textStyle={"b-sm"} ml={-1} variant={"secondary"}>
            Produk telah dihapus
          </Text>
        </>
      ) : (
        <>
          <HStack>
            <HStack
              w={"fit-content"}
              cursor={"pointer"}
              onClick={() => {
                navigate(`/product/${data?.prefix}/${data?.slug}`);
              }}
            >
              <Image
                src={
                  data?.img
                    ? `${process.env.REACT_APP_MEDIA_URL}${data?.img}`
                    : ""
                }
                alt={data?.name || "Product Image"}
                objectFit={"cover"}
                w={"100%"}
                maxW={["60px", null, "75px"]}
                borderRadius={"md"}
                fallbackSrc="/assets/svg/illustration_empty.svg"
                style={{ aspectRatio: 1 / 1 }}
              />

              <VStack gap={0} align={"stretch"}>
                <Text
                  textStyle={"b-reg"}
                  noOfLines={1}
                  textOverflow={"ellipsis"}
                >
                  {data?.name}
                </Text>

                <Text textStyle={"b-reg-sb"}>
                  {data && formatNumber(data?.price)}
                </Text>

                <Badge w={"fit-content"} mt={[1, null, 2]} colorScheme="green">
                  {data?.variantName}
                </Badge>
              </VStack>
            </HStack>
          </HStack>

          {onCloseProduct && (
            <IconButton
              aria-label="close-product-chat"
              mr={2}
              size={"xs"}
              colorScheme="black"
              icon={
                <Icon
                  as={RiCloseCircleLine}
                  color={"red.400"}
                  fontSize={[16, null, 18]}
                />
              }
              onClick={() => {
                onCloseProduct();
              }}
            />
          )}
        </>
      )}
    </HStack>
  );
};
